// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2ZzU5","modalFooterButton":"ModalNotes_modalFooterButton__13W4s"};